export default __webpack_public_path__ + "2a130b024a3d7a5c726227961501e92f.svg";